import { render, staticRenderFns } from "./LogoSettings.vue?vue&type=template&id=0069a1fc&"
import script from "./LogoSettings.vue?vue&type=script&lang=ts&"
export * from "./LogoSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports